import { ResultOf } from '@graphql-typed-document-node/core'

import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'
import { useFeatureFlag } from '../../lib/feature-flagging/context.js'
import { isBlockKind } from '../is-block-kind.js'
import { Blocks } from './blocks.jsx'

export const experimentFragment = cmsGraphql(/* GraphQL */ `
  fragment experimentFragment on CmsExperiment {
    featureFlag {
      key
      value
    }
    layout {
      __typename
      ...callToActionBlockFragment
      ...devicePreviewFragment
      ...contentFragment
      ...archiveFragment
      ...quoteFragment
      ...crossLinksFragment
      ...accordionFragment
      ...featureSectionFragment
      ...carouselFragment
      ...bentoFragment
      ...priceTierFragment
      ...formBlockFragment
      ...resourcesFragment
      ...featureGridFragment
      ...disclaimersFragment
      ...legalBlockFragment
      ...videoBlockFragment
      ...richTextSectionFragment
      ...offerBlockFragment
      ...tableBlockFragment
      ...imageBlockFragment
      ...downloadBannerFragment
      ...calloutBlockFragment
      ...videoEmbedBlockFragment
      ...alertBannerBlockFragment
      ...richTextBlockFragment
    }
  }
`)

export const experimentBlockTypename = 'CmsExperiment'
const experimentBlockType = 'experiment'

export const isExperimentBlock = (block: unknown): block is ResultOf<typeof experimentFragment> => {
  return isBlockKind(block, experimentBlockTypename, experimentBlockType)
}

export type ExperimentProps = {
  data: FragmentType<typeof experimentFragment>
}

export const Experiment = ({ data }: ExperimentProps) => {
  const { featureFlag, layout } = getFragmentData(experimentFragment, data)
  const flagValue = useFeatureFlag(featureFlag?.key ?? undefined, false)

  if (!featureFlag || !featureFlag.key || featureFlag.value === null || featureFlag.value === undefined) {
    return null
  }

  const value = JSON.parse(featureFlag.value)

  if (flagValue !== value) {
    return null
  }

  return <Blocks blocks={layout} />
}
